import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const useRedirect = () => {
	const location = useLocation();
	const navigate = useNavigate();

	useEffect(() => {
		if (location.pathname === '/') navigate('/imms', { replace: true });
	}, [location.pathname]);
};

export default useRedirect;
